module.exports = __webpack_public_path__ + "static/media/dollar_loader.4032c4b4.gif";